import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const START_SECONDS = 14 * 60 + 55;
function format(total: number): string {
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
export function UrgencyBar() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  return <div className="sticky top-0 z-50 w-full bg-alert text-cream" data-id="element-253" data-mp="2p5byxw04x16g">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2.5 text-center" data-id="element-254" data-mp="2p3hfyn8fbj50">
        <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-255" data-mp="2f761bqld2h7e" />
        <p className="text-[11px] font-bold uppercase tracking-[0.12em] sm:text-xs" data-id="element-256" data-mp="2f9iezrk365en">
          Special launch offer: 90% off ends in
        </p>
        <span className="rounded-md bg-espresso/40 px-2 py-0.5 font-sans text-xs font-bold tabular-nums tracking-widest sm:text-sm" role="timer" aria-live="off" data-id="element-257" data-mp="1rwsrhufhqj5g">
          {format(remaining)}
        </span>
        <span className="hidden h-3 w-px bg-cream/40 sm:block" aria-hidden="true" data-id="element-258" data-mp="1i0xzi8pdnbq0" />
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-cream/90 sm:text-xs" data-id="element-259" data-mp="1myr632ule7qt">
          Join 5,000+ empowered stylists today
        </p>
      </div>
    </div>;
}